export const TZ_SEOUL = 'Asia/Seoul';
